import React from "react";
import Tilt from "react-tilt";
import FAQ from "../Pages/FAQ";

import Menu from "./Navbar";
import Feature from "./Feature";
import Price from "./Price";
import Footer from "./Footer";

import { Link } from "react-scroll";

import dict from "../utils/dictionary";
import { Helmet } from "react-helmet";

const Home = () => {
  const dictionary = dict()["home"];

  return (
    <div>
      <Helmet>
        {" "}
        <title>{dictionary["pageTitle"]}</title>
      </Helmet>

      <Menu homePage="home-one" />

      <section className="back-img ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 col-xl-5 offset-xl-2">
              <div className="home-contain">
                <div className="fadeInLeft-land-caption" style={{ marginTop: "-80px" }}>
                  {/* <img src={`${process.env.PUBLIC_URL}/assets/images/landing-logo.png`} alt="logo" className="main-logo" /> */}
                  <h1 style={{ lineHeight: "1.3", fontWeight: "600", fontSize: "2.5rem" }}>{dictionary["mainTextHomePage"]}</h1>

                  <div style={{ gap: "20px", display: "flex", flexWrap: "wrap" }}>
                    <Link href="#" activeClass="active" to={"price"} spy={true} smooth={true} offset={-50} duration={500}>
                      <div className="btn btn-custom" style={{ backgroundColor: "rgb(187 4 115)" }}>
                        <span>{dictionary["normalAccountsButtonText"]}</span>
                      </div>
                    </Link>
                    <a href="/skins">
                      <div style={{ backgroundColor: "rgb(187 4 115)" }} className="btn btn-custom theme-color skin-accs-btn">
                        <span>{dictionary["skinsAccountsButtonText"]}</span>
                      </div>
                    </a>

                    <a target="_blank" href={`https://www.instagram.com/arcane.smurfs`}>
                      <div style={{ backgroundColor: "rgb(236 0 80)" }} className="btn btn-custom theme-color">
                        <span>Conocenos en Instagram</span>
                      </div>
                      {dictionary["email"]}
                    </a>
                  </div>

                  {/* New prominent skin button */}
                  <div style={{ marginTop: "25px", width: "100%" }}>
                    <a href="https://skins.arcanesmurfs.com">
                      <div
                        className="btn btn-custom theme-color"
                        style={{
                          backgroundColor: "#ff1744",
                          background: "linear-gradient(135deg, #ff1744 0%, #d50000 100%)",
                          fontSize: "1.1rem",
                          padding: "18px 35px",
                          boxShadow: "0 4px 15px rgba(255, 23, 68, 0.4)",
                          transform: "scale(1.05)",
                          position: "relative",
                          animation: "pulse 2s infinite",
                          border: "2px solid #fff",
                          fontWeight: "bold",
                          display: "inline-block",
                          width: "auto",
                        }}
                      >
                        <span style={{ position: "relative" }}>
                          AHORRA HASTA 60% EN SKINS CON NUESTRA NUEVA TIENDA!
                          <span
                            style={{
                              position: "absolute",
                              top: "-12px",
                              right: "-45px",
                              backgroundColor: "#00e676",
                              color: "#000",
                              padding: "2px 8px",
                              borderRadius: "12px",
                              fontSize: "0.7rem",
                              fontWeight: "bold",
                              boxShadow: "0 2px 8px rgba(0, 230, 118, 0.5)",
                              transform: "rotate(12deg)",
                              animation: "bounce 1.5s infinite",
                            }}
                          >
                            NUEVO!
                          </span>
                        </span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-4 sm-d-none">
              {/* <HireUs /> */}
              <div className="home-contain fadeIn-mac">
                <Tilt
                  options={{
                    perspective: 110,
                    speed: 400,
                    max: 1.2,
                    scale: 1,
                  }}
                >
                  <img src={`${process.env.PUBLIC_URL}/assets/images/mundo.webp`} alt="mac" className="img-fluid" style={{ maxWidth: "200%" }} />
                </Tilt>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Add CSS animations */}
      <style jsx>{`
        @keyframes pulse {
          0% {
            transform: scale(1.05);
          }
          50% {
            transform: scale(1.08);
          }
          100% {
            transform: scale(1.05);
          }
        }

        @keyframes bounce {
          0%,
          100% {
            transform: rotate(12deg) translateY(0);
          }
          50% {
            transform: rotate(12deg) translateY(-5px);
          }
        }
      `}</style>

      <Feature />

      <Price />

      <FAQ />
      <div className="skins-title">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-sm-12 col-text-center d-align-center">
              {/* <h2 className='title' style={{ justifyContent: 'center', display: 'flex', color: '#dadada' }}>
								<span></span>
							</h2> */}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
